import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function SolutionSection() {
  const {
    t
  } = useLanguage();
  const steps = [{
    num: '1️⃣',
    action: t('solution.action1'),
    result: t('solution.result1')
  }, {
    num: '2️⃣',
    action: t('solution.action2'),
    result: t('solution.result2')
  }, {
    num: '3️⃣',
    action: t('solution.action3'),
    result: t('solution.result3')
  }, {
    num: '4️⃣',
    action: t('solution.action4'),
    result: t('solution.result4')
  }];
  return <section className="bg-brand-bg py-16 md:py-24" data-id="element-150">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-151">
        <div className="text-center mb-12" data-id="element-152">
          <motion.h2 className="text-3xl md:text-4xl font-bold text-brand-primary mb-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-153">
            {t('solution.title')}
          </motion.h2>
          <motion.p className="text-lg md:text-xl text-brand-text max-w-3xl mx-auto" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} data-id="element-154">
            {t('solution.subtitle')}
          </motion.p>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-155">
          <motion.div className="w-full lg:w-1/2" initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-156">
            <div className="md:hidden text-sm text-gray-500 mb-2 flex items-center justify-center" data-id="element-157">
              <span className="mr-2" data-id="element-158">←</span> {t('solution.scroll')}{' '}
              <span className="ml-2" data-id="element-159">→</span>
            </div>
            <div className="overflow-x-auto pb-4" data-id="element-160">
              <table className="w-full min-w-[600px] border-collapse bg-white rounded-xl overflow-hidden shadow-sm border border-brand-alt" data-id="element-161">
                <thead data-id="element-162">
                  <tr className="bg-brand-alt text-brand-navy" data-id="element-163">
                    <th className="py-4 px-6 text-left font-bold w-16" data-id="element-164">#</th>
                    <th className="py-4 px-6 text-left font-bold" data-id="element-165">
                      {t('solution.th1')}
                    </th>
                    <th className="py-4 px-6 text-left font-bold" data-id="element-166">
                      {t('solution.th2')}
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-brand-alt" data-id="element-167">
                  {steps.map((step, index) => <tr key={index} className="hover:bg-gray-50 transition-colors" data-id="element-168">
                      <td className="py-4 px-6 text-xl" data-id="element-169">{step.num}</td>
                      <td className="py-4 px-6 text-brand-text font-medium" data-id="element-170">
                        {step.action}
                      </td>
                      <td className="py-4 px-6 text-brand-primary font-semibold" data-id="element-171">
                        {step.result}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </motion.div>

          <motion.div className="w-full lg:w-1/2" initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} data-id="element-172">
            <div className="rounded-2xl overflow-hidden shadow-xl" data-id="element-173">
              <img src="https://cdn.magicpatterns.com/uploads/8HWWX9jzRZiC2SoMD6Kgbg/foto_1.png" alt="Representante profesional de K.J Premium Marketing en el campo" className="w-full h-auto object-cover aspect-square md:aspect-[4/3] lg:aspect-auto lg:h-[450px]" data-id="element-174" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}